import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import swal from 'sweetalert2';
import * as moment from 'moment';
import { ChallanOutModel } from '../../../model/index';
import { ChallanOutService, SubscribeService } from '../../../services/index';



@Component({
    selector: 'challanout-tab',
    templateUrl: './challanOut.component.html',
})

export class ChallanOutComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    public mode: string;
    public list: any[] = [];
    public challanoutdata: any[] = [];

    isLoadMask: Promise<any>;
    challanoutData: ChallanOutModel[];
    isLoading: boolean = false;
    scrollTimeout: any;
    suppressPaging: boolean = false;
    loadingIndicator: boolean = true;
    reorderable: boolean = true;
    chmodellist:any;
    filterData = {
        "from_date": new Date(),
        "to_date": new Date(),
    };
    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'challan_out_id',
        orderDir: 'asc'
    };
    printConfig: any = {
        // title: this.title,
        columns: [],
        rows: []
    };
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('testingamountTemplate') testingamountTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
    columns = [];

    constructor(private challanoutService: ChallanOutService, public subscribeService: SubscribeService) { }

    ngOnInit(): void {
        let that = this;
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 50, minWidth: 50, maxWidth: 50, sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Challan No', prop: 'challan_no', width: 100, minWidth: 100, maxWidth: 100, cellClass: 'cell-left' },
            { name: 'Date', prop: 'disp_date', width: 100, minWidth: 100, maxWidth: 100 },
            { name: 'Employee', prop: 'emp_name', width: 150, minWidth: 150, maxWidth: 150, cellClass: 'cell-left' },
            { name: 'Action', prop: 'sno', width: 220, minWidth: 220, maxWidth: 220, sortable: false, cellClass: 'cell-left', cellTemplate: this.editDeleteTemplate }
        ];

        this.pageCallback({ offset: 0 });
        //THIS WILL WORK WHEN ENTRY SAVED IN OTHER TAB
        this.subscribeService.publishReloadChallanOutListGrid().subscribe(($e) => {
            that.getChallanoutList();
        });
    }

    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.getChallanoutList();
        }
    }
    onOpenedFilter(){}
    /**
   * Called whenever the user changes the sort order
   */
    sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
        // there will always be one "sort" object if "sortType" is set to "single"
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy = sortInfo.sorts[0].prop;
        this.getChallanoutList();
    }
    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            //celarTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100)
    }
    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getChallanoutList();
    }
    clearFilter(): void {
        this.filterData = {
            "from_date": new Date(),
            "to_date": new Date()
        };
        this.applyFilter();
    }

    applyFilter(): void {
        //this.filterExpand = false;
        this.page.offset = 0;
        this.filterPanel.close();
        this.getChallanoutList();
    }
    getChallanoutList(): void {
        let filterData = {
            ...this.filterData,
            from_date:moment(this.filterData['from_date']).format('YYYY-MM-DD'),
            to_date:moment(this.filterData['to_date']).format('YYYY-MM-DD'),
            ser_no:this.filterData['ser_no']
        };
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            filter : JSON.stringify(filterData)
        };
        let that = this;
        this.isLoadMask = this.challanoutService
            .getChallanoutList(params)
            .then(function (res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.challanoutData = res.data;
            });
    }
    addChallanout(mode: string, row: any): void {
        let that = this;
        // setTimeout(function() {
        //     that.filterPanel.close();
        // }, 10);

        if (mode == "Add") {
            row = {
                challan_out_id: '',
                mode: mode
            };
        } else if (mode == "Edit") {
            row['mode'] = mode;
        } else if (mode == 'View') {
            row['mode'] = mode;
        }

        that.subscribeService.subScribeTabID('Transaction', 'AddEditChallanOutComponent', row, this['params']['tabParams']);


    }
    onDeleteChallanout(row: any): void {
        let that = this,
            params = {
 
                challan_out_id: row.challan_out_id
            };
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover this Challan out Details, No - ' + row['challan_no'],
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function () {
            that.loadingIndicator = true;
            that.isLoadMask = that.challanoutService
                .deleteChallanOut(params)
                .then(function (res: any) {
                    that.loadingIndicator = false;
                    if (res.success) {
                        that.getChallanoutList();
                        swal(
                            'DELETED',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }
                });

        }, function (dismiss) {
        });
    }
    @ViewChild('printPage') printPage;
    onPrintReport(row: any) {
        let params={
            start: 0,
            limit: 20,
            orderColumn:"challan_out_id",
            orderBy:"challan_out_id",
            orderDir:"asc",
            challan_out_id: row.challan_out_id
        }
        let that = this;
        that.isLoadMask = this.challanoutService
            .getChallanOutModelDetails(params)
            .then(function(res:any){
                row['list']=res.data;
                that.printConfig = {
                    type: that.title,
                    title: 'SOUNDS GOOD HEARING CARE',
                    subTitle: that.title,
                    rows: row,
                    columns: that.columns

                    /*  fromdate: that.datePipe.transform(that.filterData['from_date'], 'dd-MM-yyyy'),
                     todate: that.datePipe.transform(that.filterData['date'], 'dd-MM-yyyy') */
                }
            })
        setTimeout(() => {
            that.printPage.printPreview();
        }, 100);
        /*setTimeout(() => {
            that.filterPanel.close();
        }, 100);*/
    }

    //START - CR-13
    billclick(mode: string, row: any): void {
        console.log(row);
        let that = this;
        if (mode == "HV") {
            row['mode'] = 'Add';
            row['mode1'] = 'View';
            row['branch'] = '';
            that.subscribeService.subScribeTabID('Transaction', 'AddEditSalesBillentryComponent', row, 'HV');
        } else if (mode == 'SOA') {
            row['mode'] = 'Add';
            row['mode1'] = 'View';
            row['branch'] = '';
            that.subscribeService.subScribeTabID('Transaction', 'AddEditSalesBillentryComponent', row, 'SOA');
        }

        


    }
    //END - CR-13

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/challanOut/challanOut.component.ts